import React from "react";
import PrivateApi from '../../services/PrivateApiService';
import SplashPage from '../SplashPage';
import { Col, Container, Row } from "react-bootstrap";
import ZipsList from "../../components/hw/ZipsList";
import { useQuery } from "react-query";

const ArchivePage = () => {

    const API = new PrivateApi();

    const { data, error, isLoading } = useQuery("GET_ARCHIVE_QUERY", API.get_Archive, { staleTime: Infinity });


    // if data is loading
    if (isLoading) return <SplashPage />

    // if error by data collecting
    if (error) return <SplashPage error={error} />


    return (
        <Container className="text-start">
            <Row>
                <Col>
                    <h3>Downloadarchiv</h3>
                    <p className="text-muted">Hier finden Sie alle bereits heruntergeladenen Dateien</p>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <ZipsList key="zipList" zips={data} />
                </Col>
            </Row>

        </Container>

    )
}

export default ArchivePage;